import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Airline } from 'src/app/shared/shared.models';

import { environment} from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AirlineSettingsService {
  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  postAirline(airline: Airline): Observable<any> {
    return this.http.post(this.url + 'airlines', airline);
  }

  putAirline(airline: Airline): Observable<any> {
    return this.http.put(this.url + 'airlines', airline);
  }

  deleteAirline(index: number): Observable<any> {
    return this.http.delete(this.url + 'airlines/' + index);
  }

  fetchAirlines(): Observable<any> {
    return this.http.get(this.url + 'airlines');
  }

  getAirlineById(index: number): Observable<any> {
    return this.http.get(this.url + 'airlines/'+index);
  }

  import(file: File, airlineId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.url + 'airlines/' + airlineId + '/importERateSheet/' ,
      formData
    );
  }
}
